export default __webpack_public_path__ + "static/char-thumb-61-3bd2ceb36cf7f43cef1c03c4fdf9def3.png";